import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import styled from 'styled-components'
import { Container, Col, Row, config } from 'react-awesome-styled-grid'
import HtmlHead from '@components/HtmlHead'
import type { AppStateType } from '../../reducers/appstate'
import { withRouter } from 'next/router'
import { GlobalStyle, colors, H1, P } from '@components/shared'
import TopNav from '@components/TopNav'
import { AnchorCTA } from '@components/shared/buttons'
import Footer from '@components/Footer'
import TopNavMobile from '@components/TopNavMobile'

function Index (): React.ReactNode {
  return (
    <>
      <HtmlHead
        title={'Dipsea | Voice Acting Webinar'}
        description={'Watch the Dipsea Voice Acting webinar to get a better sense of what we\'re looking for, and then submit your audition for Dipsea.'}
      />
      <GlobalStyle backgroundColor={colors.midnightBlue}/>
      <VoiceContainer>
        <TopNav backgroundColor={colors.midnightBlue95} isAssetLoaded={true}/>
        <TopNavMobile backgroundColor={colors.midnightBlue95} isAssetLoaded={true}/>
        <Container>
          <Row align="center" justify="center">
            <Col>
              <TitleH1 textAlign="center">Voice act for Dipsea</TitleH1>
              <Description>Our short, sexy audio stories are made possible by talented people – actors and non-actors alike. To get a better sense of what we’re looking for, check out our webinar below!</Description>
              <AuditionBtnContainer>
                <AnchorCTA target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSdjO1-ouXfgiVMMUfjbLPvxn4jilz6KlmywoHefDn617gPxJg/viewform">Audition now</AnchorCTA>
              </AuditionBtnContainer>
            </Col>
          </Row>
          <Row>
            <Col>
              <VideoSection>
                <VideoWrapper>
                  <VideoContainer>
                    <VideoIframe
                      src="https://player.vimeo.com/video/333863763"
                      width="100%" height="100%" frameBorder="0" allow="autoplay; fullscreen"
                      allowFullScreen></VideoIframe>
                  </VideoContainer>
                </VideoWrapper>
              </VideoSection>
            </Col>
          </Row>
        </Container>
      </VoiceContainer>
      <Footer />
    </>
  )
}

const mapStateToProps = (_state: AppStateType): any => {
  return {
  }
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Index) as any) as any

const VoiceContainer = styled.main<any>`
  background: url('/images/Voice-Actor-Dusk-Mobile.jpg') no-repeat;
  background-size: cover;
  background-color: ${colors.cobalt};
  padding: 0;
  ${(props: any): any => config(props).media.md`
    padding: 0;
    background: url('/images/Voice-Actor-Dusk.jpg') no-repeat;
  `}
`

const TitleH1 = styled(H1)<any>`
  color: ${colors.sand};
  margin-top: 48px;
  margin-bottom: 20px;
  ${(props: any): any => config(props).media.sm`
    margin-top: 90px;
  `}
  ${(props: any): any => config(props).media.md`
    margin-top: 76px;
  `}
  ${(props: any): any => config(props).media.lg`
    margin-top: 120px;
    font-size: 90px;
    line-height: 105%;
  `}
  ${(props: any): any => config(props).media.xl`
    margin-top: 138px;
  `}
`

const Description = styled(P)<any>`
  color: ${colors.sand};
  max-width: 335px;
  margin: 0 auto 30px;
  text-align: left;
  font-size: 16px;
  line-height: 150%;
  ${(props: any): any => config(props).media.sm`
    max-width: 464px;
  `}
  ${(props: any): any => config(props).media.md`
    max-width: 450px;
    text-align: center;
  `}
  ${(props: any): any => config(props).media.lg`
    max-width: 820px;
    margin-bottom: 34px;
    font-size: 18px;
    line-height: 150%;
  `}
  ${(props: any): any => config(props).media.xl`
    max-width: 862px;
  `}
`
const AuditionBtnContainer = styled.div<any>`
  box-sizing: border-box;
  max-width: 232px;
  margin: 0 auto;
`

const VideoSection = styled.div<any>`
  display: flex;
  flex-direction: row;
  justify-content: cneter;
  margin: 70px auto;
  z-index: 1;
`

const VideoWrapper = styled.div<any>`
  background-color: white;
  width: 90vw;
  height: 100%;
  max-width: 810px;
  max-height: 480px;
`
const VideoContainer = styled.div<any>`
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
`

const VideoIframe = styled.iframe<any>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
`
